import React from 'react';
import { Placement } from '@floating-ui/react';
import { cx } from '@linaria/atomic';
import type { CommonHTMLButtonAttributes } from '@frontend/types';
import type { IconProps } from '../../icon/Icon.component';
import { InfoRoundIconSmall } from '../../icon/icons-small/info-round-small';
import { NakedButton } from '../../naked/naked-button.component';
import { useTooltip } from '../tooltip/use-tooltip';
import { infoStyle } from './info.styles';

interface InfoType extends CommonHTMLButtonAttributes {
  children: React.ReactNode;
  hasInteractiveContent?: boolean;
  placement?: Placement;
  color?: IconProps['color'];
  trigger?: 'hover' | 'click';
  hoverDelay?: number;
  iconSize?: number;
}

export const Info = ({
  children,
  hasInteractiveContent,
  placement,
  color,
  trigger = 'click',
  hoverDelay,
  iconSize = 16,
  className,
  ...rest
}: InfoType) => {
  const { Tooltip, tooltipProps, triggerProps } = useTooltip({ placement, trigger, hoverDelay });
  return (
    <>
      <NakedButton type='button' className={cx(infoStyle, className)} {...rest} {...triggerProps}>
        <InfoRoundIconSmall size={iconSize} color={color} />
      </NakedButton>
      <Tooltip hasInteractiveContent={hasInteractiveContent} {...tooltipProps}>
        {children}
      </Tooltip>
    </>
  );
};
